import { createAction } from '@reduxjs/toolkit';

import type { Address, BaseAddress } from 'domains/addresses';
import type {
  AddressValidationConfirmation,
  SaveShippingAddressPayload,
  SaveShippingMethodPayload,
} from './cart_shipping.types';

const validateShippingAddress = {
  pending: createAction<Address>('checkout/validateShippingAddress/pending'),
  fulfilled: createAction<BaseAddress | undefined>('checkout/validateShippingAddress/fulfilled'),
  confirm: createAction<AddressValidationConfirmation>('checkout/validateShippingAddress/confirm'),
  cancel: createAction('checkout/validateShippingAddress/cancel'),
};

const saveShippingAddress = {
  pending: createAction<SaveShippingAddressPayload>('checkout/saveShippingAddress/pending'),
  fulfilled: createAction('checkout/saveShippingAddress/fulfilled'),
  rejected: createAction('checkout/saveShippingAddress/rejected'),
};

const saveShippingMethod = {
  pending: createAction<SaveShippingMethodPayload>('checkout/saveShippingMethod/pending'),
  fulfilled: createAction('checkout/saveShippingMethod/fulfilled'),
  rejected: createAction('checkout/saveShippingMethod/rejected'),
};

const getAllShippingMethods = {
  pending: createAction('cartShipping/getAllShippingMethods/pending'),
  fulfilled: createAction('cartShipping/getAllShippingMethods/fulfilled'),
  rejected: createAction('cartShipping/getAllShippingMethods/rejected'),
};

export default {
  validateShippingAddress,
  saveShippingAddress,
  saveShippingMethod,
  getAllShippingMethods,
};
